// extracted by mini-css-extract-plugin
module.exports = {"playerFrame":"_2a9bd77f196a4f696024a781cc546e2b","player":"_6aefe8a1b90ab6ad02fede08c1f844a1"};